<template>
  <div
    v-show="content.cacheParDefaut && content.cacheParDefaut == 'false'"
    :id="content.idHTML"
    class="col d-flex flex-column"
    :class="[jel_getClassObject(content), { 'justify-content-center': !content.justifie }]"
  >
    <EditableArea
      v-if="content.column"
      :class="[{ container: !retirerConteneur }, content.classeCssConteneur]"
      :content="content.column"
      :parentTemplateId="metadata['mgnl:template']"
    />
  </div>
</template>

<script>
import { EditableArea } from '@/vue-editor';

export default {
  name: 'Column',
  components: { EditableArea },
  props: { metadata: { type: Object, required: true }, content: { type: Object, required: true } },
  computed: {
    retirerConteneur() {
      return this.content.retirerConteneur && this.content.retirerConteneur == 'true';
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.jel_setCookieAffichage(this.content); // nextTick obligatoire
    });
  },
};
</script>

<style lang="scss" scoped>
// Passe-passe redéfinir "d-none" ici pour avoir précédence sur d-flex vs options d'affichage
.d-none {
  display: none !important;
}

.row {
  background-position: center;
  background-repeat: no-repeat;
}
.row.bgcover {
  background-size: cover;
}
.container-fluid {
  padding: 0;
}

.element-margin > div {
  margin-bottom: 3rem;
}

@media screen and (max-width: 768px) {
  .col-sm-no-padding {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}

@media screen and (max-width: 576px) {
  .col-xs-no-padding {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
</style>
